export default __webpack_public_path__ + "static/media/breakfast-overlay.9b9934e1.png";